import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleListSpecification extends FlexibleBaseSpecification {
	id: number;
	items: FlexibleModelBase[];
	title: string;
}

export class FlexibleListModel extends FlexibleModelBase {
	public readonly items: FlexibleModelBase[];
	public readonly title: string;

	constructor(spec: FlexibleListSpecification) {
		super(spec);

		this.items = spec.items;
		this.title = spec.title;
	}
}
